module.exports = __webpack_public_path__ + "static/media/closeModal.99f25462.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vacancies/closeModal.svg
// module id = 68
// module chunks = 0